var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-breadcrumbs',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('v-breadcrumbs-item',{attrs:{"to":item.href,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text)+" ")]),(index !== _vm.items.length - 1)?[_c('v-icon',[_vm._v("mdi-chevron-right")])]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }